import ko from "knockout";
import moment from "moment/moment";
import { CustomError } from "../../../fetch";

export default class OperationForm {
    parent: any;

    validationErrors: KnockoutObservableArray<CustomError>;
    shouldDisableFields: KnockoutObservable<boolean>;

    onboardingInterviewDate: KnockoutObservable<moment.Moment>;
    customerReceivedDemo: KnockoutObservable<boolean>;
    
    constructor(model: any, parent: any) {
        this.parent = parent;

        this.validationErrors = ko.observableArray<CustomError>();
        this.shouldDisableFields = ko.pureComputed(() => this.parent.onboardingStatus() !== 99);

        this.onboardingInterviewDate = ko.observable<moment.Moment>(model.start_date ? moment(model.onboarding_interview_date) : null).extend({
            errorHandler: { source: this.validationErrors, id: 'StartDate' }
        });
        
        this.customerReceivedDemo = ko.observable<boolean>(model.customer_received_demo ? model.customer_received_demo : false)
    }
}
